export interface RuntimeConfig {
  [key: string]: string | undefined;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

type RuntimeConfigKey =
  | 'REACT_APP_BACKEND_ADDRESS'
  | 'REACT_APP_NGROK_SKIP_BROWSER_WARNING'
  | 'REACT_APP_API_SERVICE_CHANNEL_PLAN_STAGE'
  | 'REACT_APP_AI_AGENT_URL'
  | 'REACT_APP_S3_BUCKET_URL'
  | 'REACT_APP_BROWSER_ROUTER'
  | `REACT_APP_${string}`
  | `NEXT_PUBLIC_${string}`;

function getWindowRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined') return {};

  return window.__RUNTIME_CONFIG__ || {};
}

export function getRuntimeConfigValue(key: RuntimeConfigKey, fallback = ''): string {
  const runtimeValue = getWindowRuntimeConfig()[key];
  if (typeof runtimeValue === 'string') return runtimeValue;

  const buildTimeValue = process.env[key];
  if (typeof buildTimeValue === 'string') return buildTimeValue;

  return fallback;
}

export const runtimeConfig = {
  get backendAddress(): string {
    return getRuntimeConfigValue('REACT_APP_BACKEND_ADDRESS');
  },
  get ngrokSkipBrowserWarning(): string {
    return getRuntimeConfigValue('REACT_APP_NGROK_SKIP_BROWSER_WARNING');
  },
  get apiServiceChannelPlanStage(): string {
    return getRuntimeConfigValue('REACT_APP_API_SERVICE_CHANNEL_PLAN_STAGE', 'PROD');
  },
  get aiAgentUrl(): string {
    return getRuntimeConfigValue('REACT_APP_AI_AGENT_URL');
  },
  get s3BucketUrl(): string {
    return getRuntimeConfigValue('REACT_APP_S3_BUCKET_URL');
  },
  get browserRouter(): string {
    return getRuntimeConfigValue('REACT_APP_BROWSER_ROUTER');
  },
};
